// extracted by mini-css-extract-plugin
export default {"main":"LensRequestStrip_main__zt5f+","content":"LensRequestStrip_content__n0wII","link":"LensRequestStrip_link__5Uubo","arrow":"LensRequestStrip_arrow__NqLwc"};